import React, { useState } from "react";
import Logo from "../../img/logo.png";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { Helmet } from "react-helmet";
import { auth, db } from "../../firebase";
import { doc, setDoc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeaderAuth from "../../global/header/HeaderAuth";
import { HiArrowLongLeft } from "react-icons/hi2";

const getDate = () => {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return `${month}/${date}/${year}`;
};

function Register() {
  const [createdDate, setCreatedDate] = useState(getDate());
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [country, setCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [role] = useState("Utilisateur");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const generateReferralCode = (uid) => {
    return uid.slice(0, 8);
  };

  const handleRetour = () => {
    setStep(step - 1);
  };

  const handleSuivant = () => {
    const validationErrors = validationInfo();
    if (Object.keys(validationErrors).length === 0) {
      setStep(step + 1);
    } else {
      setErrors(validationErrors);
    }
  };

  const validationInfo = () => {
    const errors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!fname.trim()) {
      errors.fname = "Entrer votre nom s'il vous plaît";
    }

    if (!lname.trim()) {
      errors.lname = "Entrer votre prénom s'il vous plaît";
    }

    if (!emailRegex.test(email)) {
      errors.email = "Votre adresse e-mail invalide";
    }

    if (!password.trim()) {
      errors.password = "Entrer votre mot de passe s'il vous plaît";
    } else if (password.length < 8) {
      errors.password = "Le mot de passe doit contenir au moins 8 caractères";
    } else if (!/(?=.*\d)(?=.*[a-zA-Z])/.test(password)) {
      errors.password =
        "Le mot de passe doit contenir à la fois des chiffres et des lettres";
    }

    return errors;
  };

  const validationReg = () => {
    const errors = {};

    const phoneRegex = /^\d{10}$/;

    if (!phoneRegex.test(phone)) {
      errors.phone = "Votre numéro de téléphone invalide";
    }

    if (!address.trim()) {
      errors.address = "Entrer votre adresse s'il vous plaît";
    }

    if (!city.trim()) {
      errors.city = "Entrer votre ville s'il vous plaît";
    }

    if (!postal.trim()) {
      errors.postal = "Entrer votre code postal s'il vous plaît";
    }

    if (!country.trim()) {
      errors.country = "Entrer votre pays s'il vous plaît";
    }

    return errors;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = validationReg();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      await createUserWithEmailAndPassword(auth, email, password);
      const user = auth.currentUser;

      if (user) {
        const referralCode = generateReferralCode(user.uid);
        await setDoc(doc(db, "Users", user.uid), {
          email: user.email,
          phone: phone,
          firstName: fname,
          lastName: lname,
          address: address,
          city: city,
          postal: postal,
          country: country,
          roles: role,
          referralCode: referralCode,
          referredBy: null,
          referrals: [],
          dateCreated: new Date(),
        });
      }

      toast.success("Création du compte a été succés", {
        position: "top-right",
        autoClose: 1500,
        onClose: () => {
          navigate("/auth/connexion");
          setLoading(false);
        },
      });
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
      });
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Inscription</title>
      </Helmet>
      <ToastContainer />
      <HeaderAuth />

      <div className="min-h-screen bg-gradient-to-t from-pink-100 via-pink-50 to-pink-100 flex flex-col justify-center pt-24 pb-5 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex gap-1 items-center justify-center">
            <img src={Logo} alt="Logo" className="w-10 md:w-12 lg:w-16" />
            <h3 className="text-2xl md:text-3xl lg:text-5xl poppins-bold text-black">
              ECOKAZ
            </h3>
          </div>
          <h2 className="mt-3 text-center text-xl sm:text-2xl leading-7 poppins-semibold text-gray-900">
            Connectez-vous à votre compte
          </h2>
          <p className="mt-2 text-center text-sm leading-5 text-black max-w md:text-base">
            Ou
            <Link
              to="/auth/connexion"
              className="hover:underline ho ml-1 font-medium text-blue-600 hover:text-blue-700 focus:outline-none focus:underline transition ease-in-out duration-150"
            >
              Connectez-vous à votre compte
            </Link>
          </p>
        </div>

        <div className="mt-8 mx-3 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div>
              {step === 1 ? (
                <>
                  <div>
                    <label
                      for="firstname"
                      className="block font-medium leading-5  text-gray-700"
                    >
                      Nom
                    </label>
                    <div className="mt-1 relative rounded-md">
                      <input
                        id="firstname"
                        name="firstname"
                        placeholder="Entrer votre nom"
                        type="text"
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setFname(e.target.value)}
                        required
                      />
                      {errors.fname && fname.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.fname}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <label
                      for="lastname"
                      className="block font-medium leading-5 text-gray-700"
                    >
                      Prénom
                    </label>
                    <div className="mt-1 rounded-md">
                      <input
                        id="lastname"
                        name="lastname"
                        placeholder="Entrer votre prénom"
                        type="text"
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setLname(e.target.value)}
                      />
                      {errors.lname && lname.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.lname}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <label
                      for="email"
                      className="block font-medium leading-5  text-gray-700"
                    >
                      E-mail
                    </label>
                    <div className="mt-1 relative rounded-md">
                      <input
                        id="email"
                        name="email"
                        placeholder="Entrer votre e-mail"
                        type="email"
                        required
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {errors.email && email.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.email}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <label
                      for="password"
                      className="block font-medium leading-5 text-gray-700"
                    >
                      Mot de passe
                    </label>
                    <div className="mt-1 rounded-md">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        placeholder="Entrer votre mot de passe"
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {errors.password && password.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.password}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label
                      for="username"
                      className="block font-medium leading-5 text-gray-700"
                    >
                      Téléphone
                    </label>
                    <div className="mt-1 rounded-md">
                      <input
                        id="telephone"
                        name="telephone"
                        placeholder="Entrer votre téléphone"
                        type="text"
                        value={phone}
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setPhone(e.target.value)}
                      />
                      {errors.phone && phone.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.phone}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <label
                      for="adresse"
                      className="block font-medium leading-5  text-gray-700"
                    >
                      Adresse
                    </label>
                    <div className="mt-1 relative rounded-md">
                      <input
                        id="adresse"
                        placeholder="Entrer votre adresse"
                        type="text"
                        value={address}
                        required
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setAddress(e.target.value)}
                      />
                      {errors.address && address.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.address}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <label
                      for="ville"
                      className="block font-medium leading-5  text-gray-700"
                    >
                      Ville
                    </label>
                    <div className="mt-1 relative rounded-md">
                      <input
                        id="ville"
                        placeholder="Entrer votre ville"
                        type="text"
                        value={city}
                        required
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setCity(e.target.value)}
                      />
                      {errors.city && city.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.city}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <label
                      for="postal"
                      className="block font-medium leading-5  text-gray-700"
                    >
                      Code postal
                    </label>
                    <div className="mt-1 relative rounded-md">
                      <input
                        id="postal"
                        placeholder="Entrer votre code postal"
                        type="text"
                        value={postal}
                        required
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setPostal(e.target.value)}
                      />
                      {errors.postal && postal.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.postal}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <label
                      for="pays"
                      className="block font-medium leading-5  text-gray-700"
                    >
                      Pays
                    </label>
                    <div className="mt-1 relative rounded-md">
                      <input
                        id="pays"
                        placeholder="Entrer votre pays"
                        type="text"
                        value={country}
                        required
                        className="shadow-sm w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onChange={(e) => setCountry(e.target.value)}
                      />
                      {errors.country && country.trim() === "" && (
                        <p className="text-red-500 text-xs mt-0.5">
                          {errors.country}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="mt-6">
                <span className="block w-full rounded-md shadow-sm">
                  {step === 2 && (
                    <span
                      type="button"
                      className={`w-full mb-1 flex  items-center justify-center py-2 px-4 border border-transparent poppins-bold rounded-md focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out ${
                        loading
                          ? "cursor-not-allowed text-blue-400"
                          : "cursor-pointer text-blue-500 hover:text-blue-700 hover:underline"
                      }`}
                      onClick={handleRetour}
                      disabled={loading}
                    >
                      <HiArrowLongLeft size={20} className="me-2" />{" "}
                      <span>Retour</span>
                    </span>
                  )}

                  <button
                    type="button"
                    className={`w-full flex justify-center py-2 px-4 border border-transparent poppins-bold rounded-md text-white focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out ${
                      loading
                        ? "bg-pink-300 cursor-not-allowed"
                        : "bg-black hover:bg-pink-700 cursor-pointer"
                    }`}
                    disabled={loading}
                    onClick={step === 1 ? handleSuivant : handleRegister}
                  >
                    {loading ? (
                      <span className="loading loading-dots loading-md"></span>
                    ) : (
                      <span>{step === 1 ? "Suivant" : "Créer un compte"}</span>
                    )}
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
